import React from 'react';
import { config } from '@triare/auth-redux';
import Simple from '../../../components/Layout/Simple';
import ConfirmEmailContent from '../../../components/Pages/Auth/ConfirmEmail';

const { displayName } = config;

export default function ConfirmEmail({ ...props }): React.ReactElement {
  document.title = `${displayName}: Email confirmed successfully`;

  return (
    <Simple>
      <ConfirmEmailContent {...props} />
    </Simple>
  );
}
